import isObject from 'lodash-es/isObject';
import prettyBytes from 'pretty-bytes';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { formatDuration } from '@panneau/core/utils';

/* eslint-disable react/jsx-no-useless-fragment */
var propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  placeholder: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  format: PropTypes.string,
  suffix: PropTypes.string
};
var defaultProps = {
  value: null,
  placeholder: null,
  format: null,
  suffix: null
};
var Unit = function Unit(_ref) {
  var value = _ref.value,
    placeholder = _ref.placeholder,
    format = _ref.format,
    suffix = _ref.suffix;
  var finalValue = useMemo(function () {
    if (value === null) {
      return null;
    }
    if (format === 'bytes' && !isObject(value)) {
      return prettyBytes(parseInt(value, 10));
    }
    if (format === 'dimensions') {
      var _ref2 = value || {},
        _ref2$width = _ref2.width,
        width = _ref2$width === void 0 ? null : _ref2$width,
        _ref2$height = _ref2.height,
        height = _ref2$height === void 0 ? null : _ref2$height,
        _ref2$depth = _ref2.depth,
        depth = _ref2$depth === void 0 ? null : _ref2$depth;
      var finalWidth = width !== null && width > 0 ? width : null;
      var finalHeight = height !== null && height > 0 ? height : null;
      var finalDepth = depth !== null && depth > 0 ? depth : null;
      var finalSuffix = suffix !== null ? suffix : '';
      return "".concat(finalWidth !== null ? "".concat(finalWidth).concat(finalSuffix) : '').concat(finalHeight !== null ? " x ".concat(finalHeight).concat(finalSuffix) : '').concat(finalDepth !== null ? " x ".concat(finalDepth).concat(finalSuffix) : '');
    }
    if (format === 'duration') {
      return formatDuration(value);
    }
    return value;
  }, [value]);
  return /*#__PURE__*/React.createElement("span", {
    className: "text-nowrap"
  }, finalValue || placeholder);
};
Unit.propTypes = propTypes;
Unit.defaultProps = defaultProps;

export { Unit as default };
